'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('BrowseCtrl', BrowseCtrl);

  BrowseCtrl.$inject = ['categories', 'appMode', '$state'];

  /* @ngInject */
  function BrowseCtrl(categories, appMode, $state) {
    var vm = this;
    vm.title = 'BrowseCtrl';
    vm.searchSuccess = searchSuccess;

    activate();

    ////////////////

    function activate() {
      vm.categories = categories;
      vm.appMode = appMode || 'STANDARD';
    }

    function searchSuccess(data) {
      $state.go('vnext.content.browse.searchresults', {
        query: data.body.query,
        type: data.body.filters && data.body.filters.type ? data.body.filters.type.shortName : null,
        data: data
      });
    }
  }
})();